import TravelPluginCard from "./TravelPluginCard";
export default TravelPluginCard;
